import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserDTO } from '../../types/apiType';

export interface UserState {
  user: UserDTO | null;
}

const initialState: UserState = {
  user: null,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserDTO | null>) => {
      state.user = action.payload;
    },
  },
});

export const { setUser } = userSlice.actions;

export default userSlice.reducer;
